// we patch in 'dividers' which is missing in the official TS types
var MuiDialogContent = {
    /* your custom class style overrides here */
    dividers: {
        borderTop: 0,
    },
};
export default MuiDialogContent;
//# sourceMappingURL=MuiDialogContent.js.map